import { render, staticRenderFns } from "./IM.vue?vue&type=template&id=5a0c6d8e&scoped=true&"
import script from "./IM.vue?vue&type=script&lang=js&"
export * from "./IM.vue?vue&type=script&lang=js&"
import style0 from "./IM.vue?vue&type=style&index=0&id=5a0c6d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0c6d8e",
  null
  
)

export default component.exports